import { html, nothing } from 'lit';
import { TfFormControl } from './base';

const ALLOWED_TYPES = new Set([
  'text',
  'email',
  'tel',
  'number',
  'search',
  'url',
  'password',
]);

export class TfTextField extends TfFormControl {
  static properties = {
    ...TfFormControl.properties,
    type: { type: String, reflect: true },
    min: { type: String },
    max: { type: String },
    step: { type: String },
    minlength: { type: Number },
    maxlength: { type: Number },
    pattern: { type: String },
    inputmode: { type: String },
  };

  constructor() {
    super();
    this.type = 'text';
  }

  get _resolvedType() {
    return ALLOWED_TYPES.has(this.type) ? this.type : 'text';
  }

  _onInput(event) {
    this.value = event.target.value;
    this.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
  }

  _onChange(event) {
    this.value = event.target.value;
    this.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  }

  render() {
    return html`
      <div class="field">
        ${this._renderLabel()} ${this._renderHelper()}
        <div class="field__control-wrapper">
          <input
            class="field__control"
            id=${this._controlId}
            type=${this._resolvedType}
            name=${this.name || nothing}
            .value=${this.value ?? ''}
            placeholder=${this.placeholder || nothing}
            autocomplete=${this.autocomplete || nothing}
            inputmode=${this.inputmode || nothing}
            pattern=${this.pattern || nothing}
            min=${this.min || nothing}
            max=${this.max || nothing}
            step=${this.step || nothing}
            minlength=${this.minlength ?? nothing}
            maxlength=${this.maxlength ?? nothing}
            ?required=${this.required}
            ?disabled=${this.disabled}
            aria-invalid=${this.invalid ? 'true' : 'false'}
            aria-describedby=${this._describedBy || nothing}
            aria-errormessage=${this.invalid && this.errorText
              ? this._errorId
              : nothing}
            @input=${this._onInput}
            @change=${this._onChange}
          />
          ${this._renderErrorIcon()}
        </div>
        ${this._renderError()}
      </div>
    `;
  }
}

customElements.define('tf-text-field', TfTextField);
